import { createGoogleAuthKit } from '@libs/auth/react';
import { getSession, googleAuth, logout } from './api/auth';

const GOOGLE_CLIENT_ID = import.meta.env.GOOGLE_CLIENT_ID ?? '';

if (!GOOGLE_CLIENT_ID && typeof window !== 'undefined') {
  console.warn('[auth] GOOGLE_CLIENT_ID is not set — login will fail. Set it in the environment when running build/dev.');
}

export const { useAuthStore, GoogleAuthProvider, GoogleLoginButton, AuthGuard } = createGoogleAuthKit({
  googleClientId: GOOGLE_CLIENT_ID,
  api: { getSession, googleAuth, logout },
  logPrefix: '[meme-generator-admin/auth]',
});
